<template>
  <div class="device-icon-pin__icon" :class="iconClass" :style="iconStyle">
    <span class="material-symbols-outlined" :style="{ fontSize: iconFontSize }">
      {{ icon }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  icon: string;
  size?: 'sm' | 'md' | 'lg';
  isActive?: boolean;
  activeColor?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
  isActive: false,
});

const iconFontSize = computed(() => {
  switch (props.size) {
    case 'sm':
      return '16px';
    case 'lg':
      return '28px';
    default:
      return '22px';
  }
});

const iconStyle = computed(() => (props.isActive && props.activeColor ? { color: props.activeColor } : {}));

const iconClass = computed(() => ({
  'device-icon-pin__icon--active': props.isActive && !props.activeColor,
}));
</script>

<style scoped>
.device-icon-pin__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(200, 200, 200, 0.9);
  transition: color 0.3s ease;
}

.device-icon-pin__icon--active {
  color: rgb(250, 204, 21);
}
</style>
